import React, { Fragment, useState } from "react";
import { Box, InputGroup, InputLeftAddon, Input, Flex } from "@chakra-ui/react";
import Form from "../ui/Form";
import InputComponent from "../ui/Input";
import Loader from "../ui/Loader";
import { useForm } from "react-hook-form";

export default function ProfileDetail({ user }) {
  const [progress, setProgress] = useState(0);
  const { control} = useForm();

  return (
    <Fragment>
      <Loader progress={progress} setProgress={setProgress} />

      <Box w={{ lg: "40%", base: "100%", md: "100%" }} py="2rem">
        <Form>
          <Flex align="center" justify="space-between" gap="1rem">
            <InputComponent
              value={user?.first_name || ""}
              label="First Name"
              placeholder="First Name"
              isDisabled={true}
              control={control}
              name="first_name"



            />
            <InputComponent
              value={user?.last_name || ""}
              label="Last Name"
              placeholder="Last Name"
              isDisabled={true}
              control={control}
              name="last_name"

            />
          </Flex>
          <InputComponent
            value={user?.email || ""}
            label="Email"
            placeholder="Email"
            type="email"
            isDisabled={true}
            control={control}
             name = 'email'
          />
          <InputComponent
            value={user?.member_id || ""}
            label="Member ID"
            placeholder="Member ID"
            type="text"
            isDisabled={true}
            control={control}
            name="member_id"
          />
          <InputComponent
            value={user?.phone_number || ""}
            label="Phone Number"
            placeholder="Member ID"
            type="tel"

            control={control}
            name="phone_number"
          />
          {user?.user_role?.toLowerCase() === "member" ? (
            <Flex align="center" gap="1rem">
              <InputComponent
                value={user?.department || ""}
                label="Department"
                placeholder="Department"
                isDisabled={true}
                control={control}
                name="department"
              />
              <InputComponent
                value={user?.directorate || ""}
                label="Directorate"
                placeholder="Directorate"
                isDisabled={true}
                control={control}
                name="directorate"
              />
            </Flex>
          ) : (
            <InputComponent
              value={user?.directorate}
              label="Directorate"
              placeholder="Directorate"
              isDisabled={true}
              control={control}
              name="directorate"
            />
          )}
        </Form>
      </Box>
    </Fragment>
  );
}
